import { render, staticRenderFns } from "./DialogAddService.vue?vue&type=template&id=99264f02&scoped=true"
import script from "./DialogAddService.vue?vue&type=script&lang=js"
export * from "./DialogAddService.vue?vue&type=script&lang=js"
import style0 from "./DialogAddService.vue?vue&type=style&index=0&id=99264f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99264f02",
  null
  
)

export default component.exports